module.exports = new __parcel__URL__("gra2pes-ghg-pm25-monthgrid-v1.thumbnails.total.95e16b01.png").toString();